import React, { ReactNode, useLayoutEffect, useRef, useState } from 'react';
type FitToViewportProps = {
  children: ReactNode;
};

// Guarantees a screen never needs scrolling: the screen fills the available
// height, and if its content is taller, it is scaled down uniformly to fit.
export function FitToViewport({
  children
}: FitToViewportProps) {
  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);
  const [frameHeight, setFrameHeight] = useState(0);
  const [scale, setScale] = useState(1);
  useLayoutEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return;
    const measure = () => {
      const available = outer.clientHeight;
      const natural = inner.offsetHeight;
      setFrameHeight(available);
      setScale(natural > available + 1 ? available / natural : 1);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(outer);
    ro.observe(inner);
    return () => ro.disconnect();
  }, []);
  return <div ref={outerRef} className="relative h-full w-full overflow-hidden" data-id="element-47" data-mp="9u50xo8ldls6">
      <div ref={innerRef} className="flex w-full flex-col [&>*]:flex-1" style={{
      minHeight: frameHeight || undefined,
      transform: scale < 1 ? `scale(${scale})` : undefined,
      transformOrigin: 'top center'
    }} data-id="element-48" data-mp="ernext1gur71">
        {children}
      </div>
    </div>;
}